import UAParser from 'ua-parser-js';

export const getOSFull = (): string => {
  const parser = new UAParser();
  const ua = navigator.userAgent;
  parser.setUA(ua);

  const { name, version } = parser.getOS();

  return `${name} ${version}`;
};
